import type { ContentHref } from '@generalTypes/apiTypes';
import type { RootState } from '@generalTypes/rootStateTypes';
import { selectWebPage } from '@newStore/documentApi/documentApiSelectors';
import type { WebTabComponent } from '@nodeTypeConfig/configTypes';
import { get } from 'lodash';

export const selectIsBannerReadonly = (state: RootState, config: WebTabComponent) => {
  const isBannerComponent = config.property.startsWith('options.banner');

  if (!isBannerComponent) {
    return false;
  }

  if (config.property === 'options.banner.highlight') {
    return false;
  }

  const webConfig = selectWebPage(state, state.documentUI.currentEditingNode as ContentHref);
  const bannerActive = get(webConfig, 'options.banner.highlight', false);
  return !bannerActive;
};
